export default "__VITE_ASSET__CdXmxdUn__";